import { ContactInfo } from '../types';

export const contactInfo: ContactInfo = {
  email: 'maharjanabhilekh@gmail.com',
  phone: '+1 (510) 881 3380',
  linkedin: 'https://www.linkedin.com/in/acemzn/',
  github: 'https://github.com/Avi977',
  location: 'San Francisco Bay Area'
};